export enum EmployeeRoutesNamesEnum {
  employee = 'employee',
  employeeInformation = 'employee-information',
  employeeProjects = 'employee-projects',
  employeeSettings = 'employee-settings'
}
